import { render, staticRenderFns } from "./BaikalTabs.vue?vue&type=template&id=2cbd8365"
import script from "./BaikalTabs.vue?vue&type=script&lang=js"
export * from "./BaikalTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports